import { Action } from 'redux';
import { ShoppingItem, SofaConfiguration, PredefinedConfiguration } from 'sofa-reborn-react';

// State
export interface SofaConfigurationState {
	sofaConfiguration: SofaConfiguration;
	selectedConfiguration: PredefinedConfiguration;
	missingConfiguration: PredefinedConfiguration | null;
	persistedConfiguration: string | null;
	shoppingItems: ShoppingItem[];
	predefinedConfigurationId: string | null;
	/* Used to only send statistics from PIG, series gallery and missing cover lightbox */
	galleryPredefinedConfigurationId?: string;
	updatePredefinedConfiguration: boolean;
	missingDeeplink: string | null;
}

// Actions
export const SET_SOFA_CONFIGURATION = 'SET_SOFA_CONFIGURATION';
export const SET_SELECTED_CONFIGURATION = 'SET_SELECTED_CONFIGURATION';
export const SET_MISSING_CONFIGURATION = 'SET_MISSING_CONFIGURATION';
export const SET_PERSISTED_CONFIGURATION = 'SET_PERSISTED_CONFIGURATION';
export const SET_SHOPPING_ITEMS = 'SET_SHOPPING_ITEMS';
export const SET_PREDEFINED_CONFIGURATION_ID = 'SET_PREDEFINED_CONFIGURATION_ID';
export const SET_GALLERY_PREDEFINED_CONFIGURATION_ID = 'SET_GALLERY_PREDEFINED_CONFIGURATION_ID';
export const SET_UPDATE_PREDEFINED_CONFIGURATION = 'SET_UPDATE_PREDEFINED_CONFIGURATION';
export const SET_GALLERY_VPC_CODE = 'SET_GALLERY_VPC_CODE';
export const SET_CLOSE_GALLERY = 'SET_CLOSE_GALLERY';
export const SET_MISSING_DEEPLINK = 'SET_MISSING_DEEPLINK';

interface SetSofaConfiguration extends Action {
	type: typeof SET_SOFA_CONFIGURATION;
	value: SofaConfiguration;
}

interface SetSelectedConfiguration extends Action {
	type: typeof SET_SELECTED_CONFIGURATION;
	value: PredefinedConfiguration;
}

interface SetMissingConfiguration extends Action {
	type: typeof SET_MISSING_CONFIGURATION;
	value: PredefinedConfiguration | null;
}

interface SetPersistedConfiguration extends Action {
	type: typeof SET_PERSISTED_CONFIGURATION;
	value: string | null;
}

interface SetShoppingItems extends Action {
	type: typeof SET_SHOPPING_ITEMS;
	value: ShoppingItem[];
}

interface SetPredefinedConfigurationId extends Action {
	type: typeof SET_PREDEFINED_CONFIGURATION_ID;
	value: string | null;
}

interface SetGalleryPredefinedConfigurationId extends Action {
	type: typeof SET_GALLERY_PREDEFINED_CONFIGURATION_ID;
	value: string;
}

interface SetUpdatePredefinedConfiguration extends Action {
	type: typeof SET_UPDATE_PREDEFINED_CONFIGURATION;
	value: boolean;
}

interface SetGalleryVpcCode extends Action {
	type: typeof SET_GALLERY_VPC_CODE;
}

interface SetCloseGallery extends Action {
	type: typeof SET_CLOSE_GALLERY;
	value: string;
}

interface SetMissingDeeplink extends Action {
	type: typeof SET_MISSING_DEEPLINK;
	value: string | null;
}

export type SofaConfigurationActions =
	| SetSofaConfiguration
	| SetSelectedConfiguration
	| SetMissingConfiguration
	| SetPersistedConfiguration
	| SetShoppingItems
	| SetPredefinedConfigurationId
	| SetGalleryPredefinedConfigurationId
	| SetUpdatePredefinedConfiguration
	| SetGalleryVpcCode
	| SetCloseGallery
	| SetMissingDeeplink;
